<template>
  <!-- 重构 - 结算管理 - 待结算列表 - 代理结算单 -->
  <div>
    <div class="operationControl searchboxfl">
      <div class="searchbox">
        <div title="班级编码" class="searchboxItem ci-full">
          <span class="itemLabel">班级编码:</span>
          <el-input
            v-model="retrievalDatas.projectCode"
            type="text"
            size="small"
            placeholder="请输入班级编码"
            clearable
          />
        </div>
        <div title="班级名称" class="searchboxItem ci-full">
          <span class="itemLabel">班级名称:</span>
          <el-input
            v-model="retrievalDatas.projectName"
            type="text"
            size="small"
            placeholder="请输入班级名称"
            clearable
          />
        </div>
        <div title="所属机构" class="searchboxItem ci-full">
          <span class="itemLabel">所属机构:</span>
          <el-select
            size="small"
            v-model="retrievalDatas.compOwnerId"
            remote
            :remote-method="getCompanyList"
            filterable
            clearable
            placeholder="请至少输入两个字搜索"
          >
            <el-option
              v-for="item in companyList"
              :key="item.compId"
              :label="item.compName"
              :value="item.compId"
            ></el-option>
          </el-select>
        </div>
        <div title="代理商名称" class="searchboxItem ci-full">
          <span class="itemLabel" style="min-width:6rem">代理商名称:</span>
          <el-select
            size="small"
            v-model="retrievalDatas.agencyId"
            remote
            :remote-method="getAgencyName"
            filterable
            clearable
            placeholder="请输入要查询的代理商"
          >
            <el-option
              v-for="item in agencyNameList"
              :key="item.agencyId"
              :label="item.agencyName"
              :value="item.agencyId"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="searchbox" style="margin-top: 10px">
        <div title="行政区划" class="searchboxItem ci-full">
          <span class="itemLabel">行政区划:</span>
          <el-cascader
            clearable
            filterable
            v-model="retrievalDatas.areaId"
            :options="areatreeList"
            :props="propsarea"
            size="small"
          ></el-cascader>
        </div>
        <div title="培训类型" class="searchboxItem ci-full">
          <span class="itemLabel">培训类型:</span>
          <tree
            ref="tree"
            @eventBtn="childBack"
            :ruleForm="ruleForm"
            size="small"
            @clearParams="clearParams"
            typeStu
          />
        </div>
        <div title="班级状态" class="searchboxItem">
          <span class="itemLabel">班级状态:</span>
          <el-select
            size="small"
            v-model="retrievalDatas.projectState"
            placeholder="请选择班级状态"
            clearable
          >
            <el-option
              v-for="item in ClassstatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div title="收款到账状态" class="searchboxItem">
          <span class="itemLabel" style="min-width:7rem">收款到账状态:</span>
          <el-select
            size="small"
            v-model="retrievalDatas.accountState"
            placeholder="请选择收款到账状态"
            clearable
          >
            <el-option
              v-for="item in accountStateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="searchbox" style="margin-top: 10px">
        <div title="开班开始时间" class="searchboxItem">
          <span class="itemLabel" style="min-width: 7rem">开班开始时间:</span>
          <el-date-picker
            clearable
            size="small"
            v-model="retrievalDatas.openClassStartTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </div>
        <div title="开班结束时间" class="searchboxItem">
          <span class="itemLabel" style="min-width: 7rem">开班结束时间:</span>
          <el-date-picker
            clearable
            size="small"
            v-model="retrievalDatas.openClassEndTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </div>
      </div>
      <div class="searchbox" style="margin-top: 10px">
        <div title="到账时间" class="searchboxItem">
          <span class="itemLabel" style="min-width: 7rem">到账时间:</span>
          <el-date-picker
            clearable
            size="small"
            v-model="retrievalDatas.receiptTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </div>
        <div class="df" style="padding-left: 10px">
          <el-button
            type="primary"
            class="bgc-bv"
            round
            @click="getData((pageNum = 1), 'search')"
            >查询</el-button
          >
          <el-button
            type="primary"
            class="bgc-bv"
            round
            @click="generateStatement"
            >生成结算单</el-button
          >
        </div>
      </div>
    </div>
    <div class="framePage-scroll">
      <div class="ovy-a">
        <el-table
          ref="multipleTable"
          :data="tableData"
          :height="tableHeight"
          size="small"
          tooltip-effect="dark"
          style="width: 100%"
          row-key="billProjectId"
          @selection-change="checkListData"
          :header-cell-style="tableHeader"
          stripe
          ><el-table-column
            type="selection"
            width="50px"
            align="center"
            fixed
            :reserve-selection="true"
            :selectable="selectable"
          ></el-table-column>
          <el-table-column
            label="序号"
            align="left"
            type="index"
            :index="indexMethod"
            fixed
            width="60px"
          />
          <el-table-column
            label="班级编码"
            align="left"
            show-overflow-tooltip
            prop="projectCode"
            width="200"
          />
          <el-table-column
            label="收款结算单编号"
            align="left"
            show-overflow-tooltip
            prop="billNo"
            width="200"
          />
          <el-table-column
            label="班级名称"
            align="left"
            show-overflow-tooltip
            prop="projectName"
            width="300"
          />
          <el-table-column
            label="所属机构"
            align="left"
            show-overflow-tooltip
            prop="compName"
            width="120"
          />
          <el-table-column
            label="行政区划"
            align="left"
            show-overflow-tooltip
            prop="areaNamePath"
            width="150"
          />
          <el-table-column
            label="培训类型"
            align="left"
            show-overflow-tooltip
            prop="trainTypeNamePath"
            width="150"
          />
          <el-table-column
            label="行业类型"
            align="left"
            show-overflow-tooltip
            prop="industryNamePath"
            width="150"
          />
          <el-table-column
            label="岗位类型"
            align="left"
            show-overflow-tooltip
            prop="postName"
            width="150"
          />
          <el-table-column
            label="职业/工种"
            align="left"
            show-overflow-tooltip
            prop="occupationNamePath"
            width="150"
          />
          <el-table-column
            label="培训等级"
            align="left"
            show-overflow-tooltip
            prop="trainLevelName"
            width="100"
          />
          <el-table-column
            label="班级状态"
            align="left"
            show-overflow-tooltip
            prop="auditState"
            width="100"
          >
            <template slot-scope="scope">
              {{ $setDictionary("PROJECTSTATE", scope.row.projectState) }}
            </template>
          </el-table-column>
          <el-table-column
            label="班级开始时间"
            align="left"
            prop="startDate"
            width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.startDate | momentDate }}
            </template>
          </el-table-column>
          <el-table-column
            label="班级结束时间"
            align="left"
            prop="endDate"
            width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.endDate | momentDate }}
            </template>
          </el-table-column>
          <el-table-column
            label="结业人数"
            align="left"
            show-overflow-tooltip
            prop="settleNum"
            width="100"
          />
          <el-table-column
            label="总课时"
            align="left"
            show-overflow-tooltip
            prop="totalPeriod"
            width="100"
          />
          <el-table-column
            label="公共课时"
            align="left"
            show-overflow-tooltip
            prop="publicLessonNum"
            width="100"
          />
          <el-table-column
            label="是否到账"
            align="left"
            show-overflow-tooltip
            prop="accountState"
          >
          <template slot-scope="scope">
            {{accountStateList.find(e=>e.value == scope.row.accountState)?accountStateList.find(e=>e.value == scope.row.accountState).label:''}}
          </template>
          </el-table-column>
          <el-table-column
            label="到账日期"
            align="left"
            prop="payeeDate"
            width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.payeeDate | momentDate }}
            </template>
          </el-table-column>
          <Empty slot="empty" />
        </el-table>
      </div>
    </div>
    <PageNum :apiData="apiData" @sizeChange="sizeChange" @getData="getData" />
    <div class="Batch">
      <div class="BatchBox">
        <div class="BatchBoxFirst">
          <p>已选班级</p>
          <p>（{{ backArr.length }}）</p>
        </div>
        <div class="BatchBoxSecond ovy-a">
          <div class="BatchforBox">
            <div
              v-for="(item, index) in backArr"
              :key="index"
              class="BatchforFlex"
            >
              <div class="BatchImgBox" @click="deleteImg(item)">
                <img
                  :src="require('@/assets/close_.png')"
                  alt=""
                  @mouseover="transToWhite(index, $event)"
                  @mouseleave="transToBlack(index, $event)"
                />
              </div>
              <span style="padding-left: 5px">{{ item.projectName }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Empty from "@/components/Empty.vue";
import PageNum from "@/components/PageNum.vue";
import List from "@/mixins/List";
import tree from "@/components/treePopup";
export default {
  name: "toBeSettledListChildrenThree",
  components: {
    Empty,
    PageNum,
    tree,
  },
  mixins: [List],
  props: ["name", "multipleTable", "backArrs"],
  data() {
    return {
      // 页面检索数据
      retrievalDatas: {
        projectCode: "", // 班级编码
        compOwnerId: "", // 所属机构
        projectName: "", // 班级名称
        areaId: "", // 行政区划
        params: {}, // 培训类型
        projectState: "", // 班级状态
        agencyId: "", // 代理商id
        accountState:'30', //到账状态
        openClassStartTime: [], // 开班开始时间
        openClassEndTime: [], // 开班结束时间
        receiptTime: [], // 到账时间
      },
      // 课程提供方 - 下拉数据
      companyList: [],
      // 行政区划 - 下拉数据
      areatreeList: [],
      // 行政区划 - 整理数据
      propsarea: {
        value: "value",
        label: "label",
        emitPath: false,
        checkStrictly: true,
      },
      // 回显 - 培训类型数据
      ruleForm: {
        Trainingtype: "",
      },
      // 班级状态 - 下拉数据
      ClassstatusList: [],
      // 代理商 - 下拉数据
      agencyNameList: [],
      // 列表勾选的数据
      multipleSelection: [],
      // 已选班级的底部数据
      backArr: [],
      //是否到账
      accountStateList:[
        {
          value: "10",
          label: "未到账",
        },
        {
          value: "20",
          label: "部分到账",
        },
        {
          value: "30",
          label: "全部到账",
        },
      ]
    };
  },
  computed: {},
  created() {
    this.getareatree();
    this.getclassstatusList();
  },
  updated() {
    setTimeout(() => {
      this.tableData.forEach((item, index) => {
        this.$refs.multipleTable.toggleRowSelection(
          item,
          this.backArr.some((one) => item.billProjectId == one.billProjectId)
        );
      });
    }, 200);
  },
  methods: {
    // 鼠标移入移出
    transToWhite(index, e) {
      e.target.src = require("@/assets/error.png");
    },
    // 鼠标移入移入
    transToBlack(index, e) {
      e.target.src = require("@/assets/close_.png");
    },
    // 删除已选
    deleteImg(itemobj) {
      var newArr = this.backArr.filter((item) => item.billProjectId != itemobj.billProjectId);
      this.backArr = newArr;
      // this.multipleSelection = newArr;
      // this.$forceUpdate();
      this.multipleSelection.find((el, index) => {
        if (el.billProjectId == itemobj.billProjectId) {
          delete this.multipleSelection[index];
          this.$refs.multipleTable.toggleRowSelection(el, false);
        }
      });
    },
    // 获取 - 所属机构
    getCompanyList(query) {
      if (query.trim().length >= 2) {
        this.$post("/sys/company/queryCompanyList", { compName: query })
          .then((res) => {
            if (res.status == 0) {
              this.companyList = res.data || [];
            }
          })
          .catch(() => {
            return;
          });
      } else {
        this.companyList = [];
      }
    },
    // 获取行政区划
    getareatree() {
      this.$post("/sys/area/tree").then((ret) => {
        this.areatreeList = ret.data;
      });
    },
    // 培训类型 - 选中
    childBack(params) {
      this.retrievalDatas.params = { ...params };
    },
    // 培训类型 - 清除
    clearParams() {
      this.retrievalDatas.params = {};
    },
    // 获取 - 班级状态
    getclassstatusList() {
      const classstatuslist = this.$setDictionary("PROJECTSTATE", "list");
      const list = [];
      for (const key in classstatuslist) {
        if (key == "50" || key == "60") {
          list.push({
            value: key,
            label: classstatuslist[key],
          });
        }
      }
      this.ClassstatusList = list;
    },
    // 根据关键字获取代理商名称
    getAgencyName(query) {
      this.$post("/biz/mercantile/agency/searchList", {
        agencyName: query,
        agencyCooperationType: 20, // 不知道干啥的,后台默认让这么给
      })
        .then((res) => {
          ;
          if (res.status == 0) {
            this.agencyNameList = res.data || [];
          }
        })
        .catch(() => {
          return;
        });
    },
    // 获取 - 列表数据
    getData(pageNum = 1, stu) {
      const params = {
        pageNum: pageNum,
        pageSize: this.pageSize,
        accountState: this.retrievalDatas.accountState
      };
      // 课程名称
      if (this.retrievalDatas.projectCode) {
        params.projectCode = this.retrievalDatas.projectCode;
      }
      // 课程提供方
      if (this.retrievalDatas.compOwnerId) {
        params.compId = this.retrievalDatas.compOwnerId;
      }
      // 使用班级
      if (this.retrievalDatas.projectName) {
        params.projectName = this.retrievalDatas.projectName;
      }
      // 行政区划
      if (this.retrievalDatas.areaId) {
        params.areaId = this.retrievalDatas.areaId;
      }
      // 培训类型 - 五棵树要传的数据
      if (this.retrievalDatas.params.trainFormId) {
        params.trainTypeId = this.retrievalDatas.params.trainFormId;
      }
      if (this.retrievalDatas.params.levelFormId) {
        params.trainLevelId = this.retrievalDatas.params.levelFormId;
      }
      if (this.retrievalDatas.params.occFormId) {
        params.occupationId = this.retrievalDatas.params.occFormId;
      }
      if (this.retrievalDatas.params.postFormId) {
        params.postId = this.retrievalDatas.params.postFormId;
      }
      if (this.retrievalDatas.params.industryFormId) {
        params.industryId = this.retrievalDatas.params.industryFormId;
      }
      // 班级状态1
      if (this.retrievalDatas.projectState) {
        params.projectState = this.retrievalDatas.projectState;
      }
      // 代理商名称
      if (this.retrievalDatas.agencyId) {
        params.agencyId = this.retrievalDatas.agencyId;
      }
      // 开班开始时间
      if (this.retrievalDatas.openClassStartTime) {
        params.startDateStart = this.retrievalDatas.openClassStartTime[0];
        params.startDateEnd = this.retrievalDatas.openClassStartTime[1];
      }
      // 开班结束时间
      if (this.retrievalDatas.openClassEndTime) {
        params.endDateStart = this.retrievalDatas.openClassEndTime[0];
        params.endDateEnd = this.retrievalDatas.openClassEndTime[1];
      }
      // 到账时间
      if (this.retrievalDatas.receiptTime) {
        params.payeeDateStart = this.retrievalDatas.receiptTime[0];
        params.payeeDateEnd = this.retrievalDatas.receiptTime[1];
      }
      this.doFetch({
        url: "/biz/new/agentBill/pageList",
        params,
        pageNum,
      });
      console.log(this.tableData);
      // this.multipleSelection = this.backArr;
    },
    // // 处理混入tableData数据
    // handleListDataBack(data) {
    //   this.tableData = [];
    //   data.map((el) => {
    //     el.billProjectId = el.projectId + el.billId;
    //     this.tableData.push(el);
    //   });

      
    // },
    // 勾选列表数据
    checkListData(val) {
      this.backArr = val;
      this.multipleSelection = val;
    },
    // 生成结算单
    generateStatement() {
      if (this.multipleSelection.length > 0) {
        let projectIds = [];
        for (let i = 0; i < this.multipleSelection.length; i++) {
          projectIds.push({
            projectId: this.multipleSelection[i].projectId,
            billId: this.multipleSelection[i].billId,
            contractId: this.multipleSelection[i].contractId,
          });
        }
        // if (new Set(this.multipleSelection.map(t => t.trainTypeId)).size > 1) {
        //   this.$message({
        //       message: "不同培训类型(第一棵树)不能生成一个结算单",
        //       type: "error",
        //     });
        //   return;
        // }
        //     if (new Set(this.multipleSelection.map(t => t.compOwnerId)).size > 1) {
        //       this.$message({
        //           message: "课程提供方不同,无法生成一个结算单",
        //           type: "error",
        //         });
        //       return;
        //    }
        this.$post("/biz/new/agentBill/generateStatement", {
          list: projectIds,
        })
          .then((res) => {
            if (res.status == 0) {
              this.$router.push({
                path: "/web/financialSettlement/settlement/singleAdministrationChildrenThreeEdit",
                query: {
                  editInfo: JSON.stringify({
                    id: projectIds,
                    type: "three",
                    addEdit: "add",
                  }),
                },
              });
            }
          })
          .catch(() => {
            return;
          });
      } else {
        this.$message({
          message: "请至少勾选一项!",
          type: "warning",
        });
      }
    },
    // 列表高度
    getTableHeight(opDom = true, page = true) {
      let tHeight =
        window.innerHeight - (3 + 1.35 + 3.25 + 0.675 + 2 + 1.35 + 5 + 3) * 16;
      if (opDom) {
        tHeight -= 40 + 82 + 0.675 * 16 + 1 + 40 + 15;
      }
      if (page) {
        tHeight -= 32;
      }
      this.tableHeight = tHeight;
    },
  },
  mounted: function () {},
  watch: {
    name(newVal) {
      if (newVal == "three") {
        this.getData();
        this.$refs.multipleTable.clearSelection();
      }
    },
    $route: {
      handler: function (val) {
        if (val.query.refresh) {
          this.getData();
          this.backArr = [];
          this.$refs.multipleTable.clearSelection();
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
};
</script>
<style lang="less" scope>
.searchboxfl {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start !important;
}
</style>
<style lang="less">
.el-textarea {
  resize: none;
  .el-textarea__inner {
    height: 200px;
  }
}
.listWrap {
  .el-icon-arrow-down {
    font-size: 12px;
    &:before {
      content: "\e6df" !important;
    }
  }
  .el-tabs {
    flex: 1;
    display: flex;
    flex-direction: column;
    .el-tabs__content {
      flex: 1;
      .el-tab-pane {
        height: 100%;
      }
    }
  }
}
.Batch {
  padding: 1rem 1rem;
  position: absolute;
  bottom: 0px;
  width: 100%;
  .BatchBox {
    display: flex;
    height: 70px;
    border: 1px solid #ebeef5;
    border-radius: 5px;
    .BatchBoxFirst {
      width: 260px;
      background: #f2f7fd;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .BatchBoxSecond {
      width: 100%;
      .BatchforBox {
        display: flex;
        flex-wrap: wrap;
        .BatchforFlex {
          display: flex;
          align-items: center;
          padding: 5px 20px;
          cursor: pointer;
          .BatchImgBox {
            display: flex;
            justify-content: center;
            align-items: center;
          }
          img {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
  }
}
</style>
